import { motion } from "framer-motion";
import { ArrowRight, ChevronDown } from "lucide-react";
import heroBg from "../assets/hero-bg.png";

export const Hero = () => {
  const handleScrollTo = (e, target) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden bg-[#0A0A0A] grain"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroBg}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 pt-32 pb-24 md:pt-40 md:pb-32">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="max-w-4xl"
          >
            <motion.span
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
              style={{ transformOrigin: "left" }}
              className="block w-12 h-[2px] bg-[#E10600] mb-10"
              aria-hidden="true"
            />

            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
              data-testid="hero-title"
              className="font-serif text-white text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] leading-[1.02] tracking-tight"
            >
              L'immobilier,
              <br />
              <span className="italic font-normal text-white/90">autrement.</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
              data-testid="hero-subtitle"
              className="mt-10 md:mt-12 max-w-2xl text-base md:text-lg text-white/75 font-light leading-relaxed"
            >
              LJMG accompagne les agences immobilières dans leur développement
              commercial et la mise en relation qualifiée avec leurs clients.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.65, ease: [0.22, 1, 0.36, 1] }}
              className="mt-14 md:mt-16"
            >
              <a
                href="#about"
                onClick={(e) => handleScrollTo(e, "#about")}
                data-testid="hero-cta-button"
                className="cta-link"
              >
                <span>Découvrir</span>
                <ArrowRight className="arrow" size={18} strokeWidth={1.5} />
              </a>
            </motion.div>
          </motion.div>
        </div>

        {/* Bottom row: edition mark + scroll indicator */}
        <div className="absolute bottom-8 left-0 right-0 z-10">
          <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 flex items-end justify-between">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.9 }}
              className="hidden md:flex items-center gap-4 text-white/40 text-xs tracking-[0.2em] uppercase font-light"
            >
              <span className="block w-8 h-px bg-white/30" />
              <span>Cabinet de conseil — Paris</span>
            </motion.div>

            <motion.button
              type="button"
              onClick={(e) => handleScrollTo(e, "#about")}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 1 }}
              className="scroll-indicator mx-auto md:mx-0 flex flex-col items-center text-white/50 hover:text-white transition-colors"
              aria-label="Faire défiler vers le bas"
              data-testid="hero-scroll-indicator"
            >
              <span className="text-[10px] tracking-[0.3em] uppercase mb-3">Défiler</span>
              <ChevronDown size={20} strokeWidth={1.25} />
            </motion.button>

            <span className="hidden md:block w-[140px]" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
};
